import { Spinner } from '@/components/ui/spinner';

export function LoadingScreen() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-background">
            <div className="flex flex-col items-center space-y-4">
                <Spinner size="lg" />
                <p className="text-muted-foreground">Loading...</p>
            </div>
        </div>
    );
}
